<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs4>
                      <v-text-field v-model="filters.vehUsg" :label="filtersLabel.vehUsg" :error-messages="errors.collect('vehUsg')" data-vv-name="vehUsg" :data-vv-as="filtersLabel.vehUsg" v-validate="'numeric|max:4'"></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field v-model="filters.vehUsgDesc" :label="filtersLabel.vehUsgDesc" :error-messages="errors.collect('vehUsgDesc')" data-vv-name="vehUsgDesc" :data-vv-as="filtersLabel.vehUsgDesc" v-validate="'name|max:40'"></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-autocomplete :items="permitStatus" v-model="filters.permitStatusCode" :label="filtersLabel.permitStatus" item-text="label" item-value="value" data-vv-name="permitStatus" :data-vv-as="filtersLabel.permitStatus" :error-messages="errors.collect('permitStatus')" clearable></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
              <div class="headline">Usages Listing</div>
            </div>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table v-bind:headers="headers" v-bind:items="items" :total-items="totalItems" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="vehUsg" :loading="loading" :no-data-text="noDataText">
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.vehUsg }}</td>
              <td class="text-xs-left">{{ props.item.vehUsgDesc }}</td>
              <td class="text-xs-left">{{ props.item.permitStatusName }}</td>
              <td class="text-xs-right" v-if="checkAccess(['vehicleReview'])">
                <table-action :rowData="props" review @review="doReview(props.item.vehUsg)" remove @remove="doPromptRemove(props.item)"></table-action>
              </td>
            </template>
          </v-data-table>
          <v-btn color="primary" dark class="mb-2" @click="doNew()">
            New Usage
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card>
        <v-dialog v-model="vehUsgDialog" width="800px" lazy v-if="checkAccess(['vehicleReview'])" persistent >
          <usage-dialog :vehUsgForm="vehUsgForm" @close="doClose" :newUsg="newUsg"></usage-dialog>
        </v-dialog>
        <confirm v-model="promptRemove" @ok="doRemove">
          Are you sure that you want to delete the selected Vehicle Usage? ({{deleteVehUsg}})
        </confirm>
      </v-flex>
    </v-layout>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI, filterQuery } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import UsageDialog from './UsageDialog'

export default {
  data() {
    return {
      headers: [
        { text: 'Usage Code', align: 'left', value: 'vehUsg' },
        { text: 'Usage Description', align: 'left', value: 'vehUsgDesc' },
        { text: 'Permit Status', align: 'left', value: 'permitStatusName' }
      ],
      totalItems: 0,
      filters: {
        vehUsg: null,
        vehUsgDesc: null,
        permitStatusName: null,
        permitStatusCode: null
      },
      filtersLabel: {
        vehUsg: 'Usage Code',
        vehUsgDesc: 'Usage Description',
        permitStatus: 'Permit Status'
      },
      vehUsgForm: {
        vehUsg: undefined,
        vehUsgDesc: undefined,
        permitStatus: undefined
      },
      vehUsgDialog: undefined,
      newUsg: undefined,
      submitting: undefined,
      loading: false,
      promptRemove: false,
      selectedVehUsg: undefined,
      deleteVehUsg: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    permitStatus() {
      return this.$store.state.vehicle.permitStatus
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async fetchData(options) {
      if (this.$store.state.vehicle.init !== 1) {
        await this.$store.dispatch('vehicle.init')
      }
      const apiUrl = this.$store.state.vehicle.menu.getVehUsgs
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: rowsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((Usg) => {
                const convertMake = {
                  vehUsg: Usg.vehUsg,
                  vehUsgDesc: Usg.vehUsgDesc,
                  permitStatusCode: Usg.permitStatusCode,
                  permitStatusName: Usg.permitStatusName
                }
                this.items.push(convertMake)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doClearFilters() {
      this.filters.vehUsg = null
      this.filters.vehUsgDesc = null
      this.filters.permitStatusCode = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    doClose() {
      this.vehUsgDialog = false
      this.newUsg = false
      this.$validator.reset()
      this.fetchData()
    },
    doNew() {
      this.$validator.reset()
      this.vehUsgDialog = true
      this.newUsg = true
    },
    async doReview(vehUsg) {
      const apiURI = this.$store.state.vehicle.menu.getVehUsg
      const expand = {
        usg: vehUsg
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.vehUsgForm.vehUsg = data.Usg.vehUsg
          this.vehUsgForm.vehUsgDesc = data.Usg.vehUsgDesc
          this.vehUsgForm.permitStatus = data.Usg.permitStatusCode
        }
        this.vehUsgDialog = true
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedVehUsg = data
        this.deleteVehUsg = data.vehUsg + ' - ' + data.vehUsgDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.vehicle.menu.deleteVehUsg
      if (apiURI) {
        this.loading = true
        const expand = {
          vehUsg: this.selectedVehUsg.vehUsg
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          // Reinit
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData(true)
  },
  created() {
    if (this.checkAccess(['vehicleReview'])) {
      this.headers.push(TableConst.tableActionHeader)
    }
  },
  components: {
    UsageDialog: UsageDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
